import "./nav.scss";

export default {
  navIcon: "left-nav-icon",
}



// WEBPACK FOOTER //
// src/layout/nav.style.js